/* eslint-disable @nx/enforce-module-boundaries */
import {
  BlockIcon,
  CompanyIndustryIconNew,
  EmployeeIcon,
  FollowIcon,
  FollowingIcon,
  FollowingIconV2,
  GroupIcon,
  ReportIcon,
  ThreeDot,
  WebsiteIcon,
} from '@mybridge/icons';
import {
  Avatar,
  Box,
  HStack,
  Heading,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  Tooltip,
  useDisclosure,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
// import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { formatCommaSeparated, formatLocation } from 'v4/lib/commons';
import { CompanyPagesContext } from 'v4/snippets/company/context';
import { useSelector, useDispatch } from 'react-redux';
import { setOpenAuthModal } from 'v4/store/actions/auth.actions';
import { UserPresenceDot } from 'v4/components/user-presence-dot';
import { CompanyLocationIcon } from '@mybridge/icons/CompanyLocation';
import { MyNetworkContext } from 'v4/components/network/context';
import { CompanyBlockReportModal } from 'v4/snippets/company/public/block-report';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const SearchCompanyCard = forwardRef(({ company, ...props }, ref) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { loggedIn } = useSelector((s) => s.user);
  const { slug } = company ?? {};
  const {
    followCompanyPage,
    followCompanyPageMut,
    isCompanyFollowed,
    unfollowCompanyPageMut,
    unfollowCompanyPage,
    currentAction,
    setCurrentAction,
  } = useContext(CompanyPagesContext);

  const reportCompanyDisc = useDisclosure();
  const {
 
    reportUserDisc,
    setSelectedUser

  } = useContext(MyNetworkContext);

  useEffect(() => {
    if (!followCompanyPageMut.isLoading) {
      setCurrentAction(null);
    }
  }, [followCompanyPageMut.isLoading]);

  useEffect(() => {
    if (!unfollowCompanyPageMut.isLoading) {
      setCurrentAction(null);
    }
  }, [unfollowCompanyPageMut.isLoading]);

  return (
    <>
      <Stack h="100%" {...props}>
        {/* MARK: HEADING */}
        <HStack alignItems="flex-start">
          <HStack pr={4}>
            <Avatar
              {...(company?.slug?.length
                ? { as: Link, href: '/c/' + company?.slug }
                : {})}
              name={company?.name}
              src={company?.image}
              size="lg"
              loading="lazy"
              w="80px"
              h="80px"
            />
          </HStack>
          <Stack flex={1} minW={0} gap={0} pt={1}>
            <Heading
              {...(company?.slug?.length
                ? { as: Link, href: '/c/' + company?.slug }
                : {})}
              fontSize="22px"
              color="#2E2E2A"
              fontWeight={"500"}
              noOfLines={1}
              title={company?.name}
            >
              {company?.name}
            </Heading>

            <Text noOfLines={1} size="sm" title={company?.company_type}>{company?.company_type}</Text>
          </Stack>
        </HStack>
        
        {/* MARK: OTHERS */}
        <Stack height={"100px"} mt={4} mb={4} spacing={2}>
          {(company?.country?.length && (company?.field_audience?.location === 1 || !Object?.hasOwn(company?.field_audience, "location"))) ? (
            <HStack alignItems="flex-start">
              <Box flexShrink={0}>
                <CompanyLocationIcon
                  color="#9F9F9F"
                  width={'17'}
                  height={'17'}
                  style={{ marginTop: '2px' }}
                />
              </Box>
              <Text size="sm">{formatLocation(company)}</Text>
            </HStack>
          ) : (
            ''
          )}

          {company?.main_industry ? (
            <HStack alignItems="flex-start">
              <Box flexShrink={0}>
                <CompanyIndustryIconNew
                  color="#9F9F9F"
                  width={'17'}
                  height="17"
                  style={{ marginTop: '2px' }}
                />
              </Box>
              <Text size="sm">{company?.main_industry}</Text>
            </HStack>
          ) : (
            ''
          )}

          {(company?.website && (company?.field_audience?.website === 1 || !Object.hasOwn(company?.field_audience, "website"))) ? (
            <HStack alignItems="flex-start">
              <Box flexShrink={0}>
                <WebsiteIcon
                  color="#9F9F9F"
                  width={'17'}
                  height="17"
                  style={{ marginTop: '2px' }}
                />
              </Box>
              <Link target="_blank"isExternal  href={company?.website} size="sm">
                {company?.website?.length > 35
                  ? company?.website?.slice(0, 35) + '...'
                  : company?.website}
              </Link>
            </HStack>
          ) : (
            ''
          )}

          {company?.follower_count ? (
            <HStack alignItems="flex-start">
              <Box flexShrink={0}>
                <FollowIcon
                  color="#9F9F9F"
                  width={'17'}
                  height="17"
                  style={{ marginTop: '2px' }}
                />
              </Box>
              <Text size="sm">{company?.follower_count}</Text>
            </HStack>
          ) : (
            ''
          )}
        </Stack>

        {/* MARK: FOLLOW and MORE and Report Modal*/}
        <Stack>
          <HStack>
            {isCompanyFollowed?.(company) ? (
              <Tooltip label={t('publicProfile.unfollow') || "Unfollow"} py={1}>
                <IconButton
                  w={'41px'}
                  height={'41px'}
                  border={'1px solid #00000033'}
                  cursor="pointer"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius={'50%'}
                  variant="none"
                  isLoading={
                    currentAction &&
                    currentAction.id === company.id &&
                    unfollowCompanyPageMut.isLoading
                  }
                  onClick={(e) => {
                    setCurrentAction(company);
                    unfollowCompanyPage?.(company);
                  }}
                  _hover={{
                    bg: 'gray.100',
                  }}
                >
                  <FollowingIcon width={20} height={20} />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip label={t('publicProfile.follow') || "Follow"} py={1}>
                <IconButton
                  w={'41px'}
                  height={'41px'}
                  border={'1px solid #00000033'}
                  cursor="pointer"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius={'50%'}
                  variant="none"
                  isLoading={
                    currentAction &&
                    currentAction.id === company.id &&
                    followCompanyPageMut.isLoading
                  }
                  onClick={(e) => {
                    if (loggedIn) {
                      setCurrentAction(company);
                      followCompanyPage?.(company);
                    } else {
                      dispatch(setOpenAuthModal('sign-in'));
                    }
                  }}
                  _hover={{
                    bg: 'gray.100',
                  }}
                >
                  <FollowIcon width={20} height={20} />
                </IconButton>
              </Tooltip>
            )}

            {!!loggedIn && (<Menu>
              <MenuButton
                w={'41px'}
                height={'41px'}
                border={'1px solid #00000033'}
                cursor="pointer"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius={'50%'}
                variant="none"
                as={IconButton}
                _hover={{
                  bg: 'gray.100',
                }}
              >
                <HStack justifyContent="center">
                  <ThreeDot width="20" height="20" />
                </HStack>
              </MenuButton>

              <MenuList>
                <MenuItem
                  onClick={(e) => {
                    setSelectedUser?.(company);
                    reportCompanyDisc?.onOpen?.();
                  }}
                  icon={<ReportIcon width="20" height="20" />}
                >
                  {t('profilePhotosVideos.report')}
                </MenuItem> 
              </MenuList>
            </Menu>)}
          </HStack>
        </Stack>

        {/* Report Modal */}
        {reportCompanyDisc?.isOpen ? (
          <CompanyBlockReportModal
            {...reportCompanyDisc}
            companyPageDetail={company}
          />
        ) : null}
      </Stack>
    </>
  );
});
